import { useEffect, useState } from "react";
import { PaginationLimit } from "../constants";

// Hook to help identify mobile view
export const useMobileView = () => {
	const [width, setWidth] = useState(window.innerWidth);

	const handleWindowSizeChange = () => setWidth(window.innerWidth);

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	const isMobile = width < 992 ? true : false;

	// returns resized pagination component based on window width
	const paginationLimit = isMobile ? PaginationLimit.LG : PaginationLimit.XL;

	return { isMobile, paginationLimit };
};
